import React, { useState , useEffect, useRef } from 'react';
import './Invisalign.css';
// import invaslign from './Images/Invisalign/IMG_20231116_143019.jpg';
import step1 from "./Images/Invisalign/IMG-20220517-WA0024.jpg";
import step2 from "./Images/Invisalign/DSC_0340.JPG";
import step3 from "./Images/Invisalign/sqr.jpg";
import imginvis from './Images/Invisalign/gifi.gif'
import do1 from './Images/Invisalign/sqr4.jpg'
import do2 from './Images/Invisalign/sqr.jpg'
import do3 from './Images/Invisalign/sqr2.jpg'
import do4 from './Images/Invisalign/sqr3.jpg'
import dental1 from '../home/Images/v1.png';
import dental2 from '../home/Images/IMG20240913134831.jpg';
import dental3 from'../home/Images/IMG_20231201_174221.jpg';
import dental4 from '../home/Images/dental2.png'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { IoLocationOutline } from "react-icons/io5";
import { IoTimeOutline } from "react-icons/io5";
import {  FaCoffee, FaChild, FaClock,  FaRegCheckCircle,FaTv,FaCalendarCheck,FaTag,FaCreditCard,  FaMedkit,  } from 'react-icons/fa';
import BeforeAfterSlider from './BeforeAfterSlider';
import BookForm from '../book_now/BookForm';

const Invisalign = () => {
  const [showMore, setShowMore] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  // Check the screen size on mount and whenever the window is resized
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 480);
    };

    // Initialize screen size state
    handleResize();

    // Event listener for resizing
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleReadMoreClick = () => {
    setShowMore(!showMore);
  };


    const steps = [
      {
        image: step1,
        title: "Step 1",
        description:
          "Dental records are taken (e.g. photos, X-rays, intra-oral scans and/or impressions).",
      },
      {
        image: step2,
        title: "Step 2",
        description:
          "Your individual 3D treatment plan is created using your records and treatment prescription.",
      },
      {
        image: step3,
        title: "Step 3",
        description:
          "A series of custom-made aligners are created with advanced 3D printing technology and will be shipped to this clinic. We will then contact you for your first aligner-fitting appointment.",
      },
 
    ];
    const points = [
        {
          id: "01",
          title: "Continue to eat the foods you enjoy, no special diet required",
          position: "left",
        },
        {
          id: "02",
          title: "Removable for special occasions",
          position: "top-right",
        },
        {
          id: "03",
          title: "Continue your oral health routine to maintain healthy teeth and gums",
          position: "bottom-right",
        },
      ];
      const featuresData = [
        {
          title: "3D Imaging",
          description: "Advanced technology helps us visualize the end result.",
          imageUrl: do1, // Replace with the actual image URL or import
        },
        {
          title: "Invisalign Aligners",
          description: "Custom-made series of aligners created for you.",
          imageUrl: do2, // Replace with the actual image URL or import
        },
        {
          title: "Doctor Check-ins",
          description: "Visit us every 6 weeks or so and we'll track your progress.",
          imageUrl: do3, // Replace with the actual image URL or import
        },
        {
          title: "Incredible Smile",
          description: "You'll start noticing results in just a few weeks!",
          imageUrl: do4, // Replace with fthe actual image URL or import
        },
      ];
      
      const [duration, setDuration] = useState(0);
  const [totalCost, setTotalCost] = useState(0);

  // Calculate the cost per week
  const costPerWeek = duration > 0 ? (totalCost / duration).toFixed(2) : 0;
const barItems = [
    {
      icon: <FaTv size={40} />,
      label: "TVs + Headphone",
    },
    {
      icon: <FaCalendarCheck size={40} />,
      label: "Curated Experience",
    },
    {
      icon: <FaTag size={40} />,
      label: "Parking ",
    },
    {
      icon: <FaCreditCard size={40} />,
      label: "Flexible Bill Plans",
    },
    {
      icon: <FaCoffee size={40} />,
      label: "Beverage Bar",
    },
    {
      icon: <FaChild size={40} />,
      label: "Kids Corner",
    },
    { icon: <FaRegCheckCircle size={40} />, label: "OSHA Approved    " },
    { icon: <FaMedkit size={40} />, label: "Emergency Priority" },
    { icon: <FaClock  size={40} />, label: " Time Management  " },
  ];


  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    draggable: false,
    swipe: false,
    centerMode: true, // This will center the middle item
    focusOnSelect: true, // Automatically focus on the selected item
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

   const bookFormRef = useRef(null);

   // Function to handle smooth scrolling
   const scrollToBookForm = (e) => {
     e.preventDefault();
     bookFormRef.current?.scrollIntoView({
       behavior: "smooth",
       block: "start",
     });
   };


  return (
    <div className="invisalign">
      <section className="invisalign-sec1">
        <div className="content">
          <div className="text-section">
            <p className="trusted-text">
              <mark className="domark">
                INVISALIGN CLEAR BRACES IN WORLI, MUMBAI
              </mark>
            </p>

            <h1 className="exceptional">
              <mark className="expmrk">Correct </mark>
            </h1>
            <h1 className="exceptional">
              <mark className="expmrk">misaligned</mark>
            </h1>
            <h1 className="exceptional">
              <mark className="expmrk"> teeth</mark>
            </h1>
            <a onClick={scrollToBookForm}>
              <button className="book-button">BOOK ONLINE</button>
            </a>
            <p className="call-text">OR CALL <a href="tel:+918882672980">088826 72980</a></p>
            {/* <p className="call-text">9582474046</p> */}
          </div>
        </div>
      </section>

      <div className="invi-sec6">
        <div className="insurance"></div>
        <div className="transparent-pricing">
          {/* <div className="icon">
          <FaTags size={30} color="#0047AB" />
        </div> */}
          {/* <h2 className="kind">SECTION6</h2> */}

          <h1>Gold Invisalign Provider - 5 Years in a Row</h1>
          <p>
            The most advanced teeth straightening system in the World with an
            International warranty. Invisalign is a removable, invisible, and
            convenient way to straighten teeth for both adults and children.
          </p>

          <p>
            {isSmallScreen && showMore && (
              <span>
                {" "}
                {/* Initially show only part of the content for small screens */}
                At Bombay Dental Company, our in-house Senior Orthodontist, Dr.
                Tushita Singh, has completed more than 10,000 cases ranging from
                mild to severe difficulty, achieving beautiful results. She has
                earned the Gold Standard Award for treatment 5 years in a row.
                Dr. Singh's expertise and dedication to patient care make her
                the ideal choice for anyone looking to achieve a perfect smile.
              </span>
            )}
            {/* Always show the full text for large screens */}
            {!isSmallScreen && (
              <>
                At Bombay Dental Company, our in-house Senior Orthodontist, Dr.
                Tushita Singh, has completed more than 10,000 cases ranging from
                mild to severe difficulty, achieving beautiful results. She has
                earned the Gold Standard Award for treatment 5 years in a row.
                Dr. Singh's expertise and dedication to patient care make her
                the ideal choice for anyone looking to achieve a perfect smile.
              </>
            )}
          </p>

          {isSmallScreen && (
            <button className="read-more-btn" onClick={handleReadMoreClick}>
              {showMore ? "Read Less" : "Read More"}
            </button>
          )}
        </div>
      </div>
      <BeforeAfterSlider />

      <div className="steps-container">
        <h1 className="steps-title">
          You and your doctor have decided that Invisalign treatment is right
          for you. What comes next?
        </h1>
        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={index} className="step-card">
              <img src={step.image} alt={step.title} className="step-image" />
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="aligner-container">
        <h1 className="aligner-title">Invisalign aligners</h1>
        <p className="aligner-subtitle">Convenient, removable</p>

        <div className="aligner-content">
          <div className="aligner-image-container">
            <img
              src={imginvis}
              alt="Invisalign aligners"
              className="aligner-image"
            />
            {points.map((point, index) => (
              <div key={index} className={`aligner-point ${point.position}`}>
                <span className="aligner-point-number">{point.id}</span>
                <p className="aligner-point-text">{point.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="features-containers">
        <h2>What You Will Get?</h2>
        <div className="features-grid">
          {featuresData.map((feature, index) => (
            <div key={index} className="feature-card">
              <img
                src={feature.imageUrl}
                alt={feature.title}
                className="feature-image"
              />
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="insur">
        <div className="cost-insurance-container">
          <div className="payment-info">
            <div className="icon">💲</div> {/* Replace with actual icon */}
            <h4>Payment Info</h4>
            <h2>How much will it cost?</h2>
            <ul>
              <li>
                The cost of Invisalign at Bombay Dental company ranges from Rs
                95000 – 2,50,000, depending on the case category.
              </li>
              <li>
                Unlike other dental clinics, Bombay dental company provides EMI
                payment options for your treatment.
              </li>
            </ul>
            <p>
              We'll never leave you in the dark. After your consultation, we’ll
              outline exactly what to budget for your Invisalign treatment.
            </p>
          </div>
          <div className="insurance-info">
            <h2>EMI Options</h2>
            <p>
              Our partners like Bajaj Insurance and Fibe EMI are available to
              guide patients personally, and help them to break down their
              payments into easy installments.
            </p>
            {/* <div className="insurance-icon">🏥</div> */}
          </div>
        </div>
      </div>
      <div className="treatment-cost-container">
        <h1>Treatment cost</h1>
        <p>Calculate the estimated cost per week of your treatment</p>
        <div className="calculator">
          <div className="input-group">
            <label htmlFor="duration">Duration (Weeks)</label>
            <input
              id="duration"
              type="number"
              value={duration}
              onChange={(e) => setDuration(Number(e.target.value))}
              placeholder="Enter weeks"
            />
          </div>
          <div className="input-group">
            <label htmlFor="totalCost">Treatment Cost (INR)</label>
            <input
              id="totalCost"
              type="number"
              value={totalCost}
              onChange={(e) => setTotalCost(Number(e.target.value))}
              placeholder="Enter total cost"
            />
          </div>
          <div className="input-group">
            <label htmlFor="costPerWeek">Cost per Week (INR)</label>
            <input id="costPerWeek" type="text" value={costPerWeek} readOnly />
          </div>
        </div>
        <p className="note">
          Think about how this compares to your habitual spending, like a few
          cups of coffee a day!*
        </p>
        <p className="disclaimer">
          *2 cups of coffee per day at ₹4 each equals ₹56 per week.
        </p>
      </div>
      <div className="home-sec8">
        <div className="book-visit-container2">
          <div className="online2">
            <h1 className="book2">
              Life time warrenty if it breaks, we fix it at no cost to you
            </h1>
          </div>
        </div>
      </div>
      <div
        className="dental-bar-menu"
        style={{ margin: " 0 0px", backgroundColor: "white" }}
      >
        <h2
          className="menu-title"
          style={{ textAlign: "center", color: " black" }}
        >
          Bombay Dental Company Menu
        </h2>
        <Slider {...sliderSettings}>
          {barItems.map((item, index) => (
            <div
              key={index}
              className="menu-item"
              style={{ textAlign: "center", height: "100%" }}
            >
              <div
                className="icon"
                style={{ marginBottom: "10px", color: " #0047AB" }}
              >
                {item.icon}
              </div>
              <p className="label" style={{ color: " #0047AB" }}>
                {item.label}
              </p>
            </div>
          ))}
        </Slider>
      </div>
      <div className="visit-us-container">
        <div className="images-container">
          <img src={dental1} alt="Waiting Area" className="image-item" />
          <img src={dental2} alt="Exam Room" className="image-item" />
          <img src={dental3} alt="Sign" className="image-item" />
          <img src={dental4} alt="Lounge" className="image-item" />
        </div>
        <div className="info-container">
          <h1 className="visit">Visit Us</h1>
          <p className="weare">
            We are conveniently located right on the Worli Naka, on the first
            floor of Atur House, opposite the Bharat Petroleum Pump. Our guards
            are very helpful, and free parking is provided easily upon asking.
          </p>
          <div className="lhflex">
            <div className="location">
              <h1 className="tp">
                <IoLocationOutline />
              </h1>
              <p>
                {" "}
                Bombay Dental Company
                <br />
                Atur House
                <br />
                First Floor, Flat no 2<br />
                Worli Naka, Worli
                <br />
                Mumbai 400018
              </p>
              <a
                href="https://maps.google.com/?q=5Bombay%20Dental%20Company%20Atur%20House%20Worli%20Naka%20Mumbai%20400018"
                className="directions-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Directions
              </a>
            </div>
            <div className="hours">
              <h1 className="tp">
                <IoTimeOutline />
              </h1>
              <p>
                {" "}
                Mon-Sat 9 am – 7 pm
                <br />
                Sun 10 am – 2 pm
                <br />
                Thursday off
              </p>
            </div>
          </div>
        </div>
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps?q=5Bombay+Dental+Company+Atur+House+Worli+Naka+Mumbai+400018&output=embed"
            width="100%"
            height="450"
            style={{ border: "8px", borderRadius: "18px " }}
            allowFullScreen
            loading="lazy"
            title="Google Maps Location of Bombay Dental Company"
          />
        </div>
      </div>
      <div className="home-sec8">
        <div className="book-visit-container">
          <div className="online">
            <h1 className="book">Book your visit online</h1>
            <p className="view">
              Book your visit online and enjoy our unique No-wait policy, so
              that you have time for what you enjoy, and not spend your precious
              time in the doctor’s waiting area. A few lucky callers every month
              will be randomly shortlisted for a free scaling and polishing
              session.
            </p>
           
          </div>
        </div>
      </div>
      <div ref={bookFormRef}> 

      <BookForm/>
      </div>
    </div>
  );
};
export default Invisalign;